import genReducer from '../core/reducer';
import types from './types';
import initialState from './initialState';

export const CONTACT_MODEL = 'contact';

export default genReducer(types, initialState);
